import { Box, Grid, Paper, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

export default function SkeletonListagemProdutos() {
  return (
    <Grid size={{ xs: 12 }}>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><Skeleton variant="text" width={120} /></TableCell>
                <TableCell><Skeleton variant="text" width={100} /></TableCell>
                <TableCell><Skeleton variant="text" width={80} /></TableCell>
                <TableCell><Skeleton variant="text" width={100} /></TableCell>
                <TableCell><Skeleton variant="text" width={100} /></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {[...Array(10)].map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant="text" width={80} height={24} />
                    <Skeleton variant="text" width={180} height={20} sx={{ mt: 0.5 }} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={140} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={120} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={160} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={100} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Skeleton variant="text" width={300} height={52} />
          </Stack>
        </Box>
      </Paper>
    </Grid>
  );
}
